"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = exports.spacing = exports.sidebarColor = exports.sidebarBackground = exports.secondaryColor = exports.secondaryAccentColor = exports.primaryColor = exports.primaryAccentColor = exports.headerTop = exports.headerScroll = exports.getGlobalField = exports.getField = exports.formBorderColor = exports.formAccentColor = exports.fontWeight = exports.fontSize = exports.fontFamily = exports["default"] = exports.color = exports.borderColor = exports.background = void 0;
var _get = _interopRequireDefault(require("lodash/get"));
var _ = require("..");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getField = exports.getField = function getField(field, _ref) {
  var theme = _ref.theme,
    colorType = _ref.colorType,
    themeField = _ref.themeField,
    overrideThemeField = _ref.overrideThemeField;
  return overrideThemeField || (0, _get["default"])(theme[colorType || 'light'], themeField || field);
};
var getGlobalField = exports.getGlobalField = function getGlobalField(field, _ref2) {
  var theme = _ref2.theme,
    themeField = _ref2.themeField;
  return (0, _get["default"])(theme.global, themeField || field);
};
var background = exports.background = function background(props) {
  return getField('backgroundColor', props);
};
var color = exports.color = function color(props) {
  return getField('color', props);
};
var primaryColor = exports.primaryColor = function primaryColor(props) {
  return getField('primaryColor', props);
};
var secondaryColor = exports.secondaryColor = function secondaryColor(props) {
  return getField('secondaryColor', props);
};
var primaryAccentColor = exports.primaryAccentColor = function primaryAccentColor(props) {
  return getField('primaryAccentColor', props);
};
var secondaryAccentColor = exports.secondaryAccentColor = function secondaryAccentColor(props) {
  return getField('secondaryAccentColor', props);
};
var borderColor = exports.borderColor = function borderColor(props) {
  return getField('borderColor', props);
};
var sidebarColor = exports.sidebarColor = function sidebarColor(props) {
  return getField('sidebar.color', props);
};
var sidebarBackground = exports.sidebarBackground = function sidebarBackground(props) {
  return getField('sidebar.backgroundColor', props);
};
var headerTop = exports.headerTop = function headerTop(props) {
  return getField('header.top', props);
};
var headerScroll = exports.headerScroll = function headerScroll(props) {
  return getField('header.scroll', props);
};
var formAccentColor = exports.formAccentColor = function formAccentColor(props) {
  return getField('form.accentColor', props);
};
var formBorderColor = exports.formBorderColor = function formBorderColor(props) {
  return props.isError ? getField('form.errorColor', props) : getField('borderColor', props);
};
var spacing = exports.spacing = function spacing(props) {
  return getGlobalField('spacing', props) || _.spacing;
};
var typography = exports.typography = function typography(props) {
  return getGlobalField('typography', props) || _.typography;
};
var fontFamily = exports.fontFamily = function fontFamily(props) {
  return getGlobalField('typography.fontFamily', props) || _.typography.fontFamily;
};
var fontSize = exports.fontSize = function fontSize(props) {
  return getGlobalField('typography.size', props) || _.typography.size;
};
var fontWeight = exports.fontWeight = function fontWeight(props) {
  return getGlobalField('typography.weight', props) || _.typography.weight;
};
var _default = exports["default"] = {
  background: background,
  color: color,
  borderColor: borderColor,
  formBorderColor: formBorderColor
};